import { Residency } from './residency.model';

/** Une résidence telle qu'on la reconnaît : son nom, sinon son adresse, et sa ville. */
export function residencyLabel(residency: Residency): string {
  return `${residency.name || residency.address}, ${residency.postalCode} ${residency.city}`;
}

/** Les résidences d'une affectation à un site, telles qu'on les reconnaît ; aucune en tournée. */
export function assignedResidencies(
  assignmentType: string | null | undefined,
  residencies: Residency[] | null | undefined,
): string[] {
  return assignmentType === 'SPECIFIC' ? (residencies ?? []).map(residencyLabel) : [];
}
